import React, { useEffect, useState } from 'react';
import ClaimProfileHeader from '../auth/claimProfile/claimProfileStep1/ClaimProfileHeader';
import CollegeRecruitingIMG from './assets/img/college-recruiting-img.png';
import NAIAIMG from './assets/img/naia-logo.png';
import NAIAIMG01 from './assets/img/naia-logo01.png';
import NCAAIMG from './assets/img/ncaa-logo.png';
import NCAAIMG01 from './assets/img/ncaa-logo01.png';
import NJCAA from './assets/img/njcaa-logo.png';
import NJCAAIMG01 from './assets/img/njcaa-logo01.png';
import CCCAA from './assets/img/cccaa-logo01.png';
import ProvenRoadMapToSuccessIMG from './assets/img/proven-road-map-to-success.png';
import ProvenRoadMapToSuccessMobileIMG from './assets/img/proven-road-map-to-success-mobile.png';
import HomeSuccessIMG01 from './assets/img/home-success-img-01.png';
import HomeSuccessIMG02 from './assets/img/home-success-img-02.png';
import HomeSuccessIMG04 from './assets/img/home-success-img-04.png';
import HomeSuccessIMG05 from './assets/img/home-success-img-05.png';
import HomeSuccessIMG06 from './assets/img/home-success-img-06.png';
import HomeSuccessIMG07 from './assets/img/home-success-img-07.png';
import HomeSuccessLogoIMG01 from './assets/img/home-success-logoimg-01.png';
import HomeSuccessLogoIMG02 from './assets/img/home-success-logoimg-02.png';
import HomeSuccessLogoIMG05 from './assets/img/home-success-logoimg-05.png';
import HomeSuccessLogoIMG06 from './assets/img/home-success-logoimg-06.png';
import DataDrivenProfileMockupIMG01 from './assets/img/data-driven-profile-mockup-img-01.png';
import CollegeSearchSystemMockupIMG01 from './assets/img/college-search-system-mockup-img-01.png';
import HomeStoriesIMG03 from './assets/img/home-stories-img-03.png';
import HomeStoriesLogoIMG03 from './assets/img/home-stories-logoimg-03.png';
import HomeStoriesLogoIMG04 from './assets/img/home-stories-logoimg-04.png';
import GetVerifiedMockupIMG01 from './assets/img/get-verified-mockup-img-01.png';
import MesssageCoachesMockupIMG01 from './assets/img/message-coaches-mockup-img-01.png';
import ResourceCenterMockupIMG01 from './assets/img/resource-center-mockup-img-01.png';
import ActivityFeedMockupIMG01 from './assets/img/activity-feed-mockup-img-01.png';
import PersonalizedCheckListMockupIMG01 from './assets/img/personalized-checklist-mockup-img-01.png';
import HomeMapIMG from './assets/img/home-map-img.jpg';
import CaliforniaCommunityCollegeAthleticAssociationIMG from './assets/img/california-community-college-athletic-association-logo.png';
import { VideoPop } from './common/videoPopup';
import { Link } from 'react-router-dom';
import AthleteTestimonials from '../../common/AthleteTestimonials';
import CoachTestimonials from '../../common/CoachTestimonials';

const AthleteLP = () => {
  const [vidID, setVidID] = useState(null),
    [isVideoPop, setIsVideoPop] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }, []);

  const openVideoModal = () => {
    // setVidID("https://www.youtube.com/embed/pzXiI7Oyyp8")
    setVidID('https://www.youtube.com/embed/6a82JWaXzPo');
    setIsVideoPop(true);
  };

  const handleClick = () => {
    window.open('https://www.sportsforceonline.com/baseball/team/', '_blank');
  };

  return (
    <>
      <ClaimProfileHeader />
      <section className="banner-lp-sec">
        <div className="container">
          <div className="banner-flexbox">
            <div className="banner-content">
              <h1 className="title">
                Get Recruited By The Right College For You
              </h1>
              <div className="short-text">
                <p>
                  Simplify your college planning and recruiting process to
                  maximize your potential offers.
                </p>
              </div>
              <div className="button-wrap">
                <a className="btn" href="https://calendly.com/sportsforceteam/consultation?month=2025-04&date=2025-04-17" target="_blank" rel="noopener noreferrer">
                  Book Your Strategy Call
                </a>
              </div>
            </div>
            <div className="video-box-wrap">
              <div className="video-img">
                <img
                  src={
                    'https://i.ytimg.com/vi/6a82JWaXzPo/maxresdefault.jpg'
                    // ClubVideoThumbnail
                  }
                  alt=""
                />
                <div
                  className="video-play-button"
                  data-toggle="modal"
                  data-target="#VideoModal"
                >
                  <div className="video-play-inner">
                    <button
                      className="play-btn"
                      onClick={() => openVideoModal()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20.191"
                        height="22.92"
                        viewBox="0 0 20.191 22.92"
                      >
                        <path
                          id="play"
                          d="M9.086,27.982a2.255,2.255,0,0,1-1.1-.291,2.442,2.442,0,0,1-1.228-2.138V7.492A2.442,2.442,0,0,1,7.982,5.353a2.242,2.242,0,0,1,2.257.028l15.641,9.24a2.226,2.226,0,0,1,0,3.8L10.236,27.663a2.262,2.262,0,0,1-1.151.319Z"
                          transform="translate(-6.754 -5.063)"
                          fill="#c0321f"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="athlete-recruiting-sec">
        <div className="container">
          <div className="flexbox">
            <div className="imgbox">
              <img
                src={CollegeRecruitingIMG}
                alt="Top 5 College Recruiting Concerns from Families Today"
              />
            </div>
            <div className="content-box">
              <h1 className="title">
                Top 5 College Recruiting Concerns from Families Today
              </h1>
              <div className="number-type-row">
                <div className="number-type-col">
                  <ul className="number-type-list">
                    <li>
                      <span className="number-count">1</span> When should we
                      start the college planning and recruiting process?
                    </li>
                    <li>
                      <span className="number-count">2</span> What type of stats
                      & grades do I need to get recruited?
                    </li>
                    <li>
                      <span className="number-count">3</span> What level of
                      colleges should we target (NCAA DI, DII, DIII, NAIA, JC)?
                    </li>
                  </ul>
                </div>
                <div className="number-type-col">
                  <ul className="number-type-list">
                    <li>
                      <span className="number-count">4</span> Who should we
                      trust (everything seems like a money grab!)?
                    </li>
                    <li>
                      <span className="number-count">5</span> Where should we go
                      for an honest recruiting assessment?
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="athlete-team-sec-outer">
        <div className="container">
          <h3 className="sec-title">
            Built for Athletes & Coaches, By Athletes & Coaches
          </h3>
        </div>
        <div className="athlete-team-sec">
          <div className="container">
            <div className="content-box">
              <h3 className="title">We're on Your Team</h3>
              <div className="short-text">
                <p>
                  As former college athletes, our team understands the
                  recruiting process can be stressful. We're on your team and
                  we're ready to help.
                </p>
                <p>
                  SportsForce provides trusted and accurate data around your
                  recruiting process. Student-athletes shouldn’t have to wonder
                  if activity from college coaches is real.
                </p>
              </div>
              {/* <div className="button-wrap">
                <button onClick={handleClick} className="btn blue">
                  Meet Our Team
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <section className="athlete-roadmap-sec">
        <div className="container">
          <div className="sec-title">A Proven Road Map To Success</div>
        </div>
        <div className="map-img">
          <img
            src={ProvenRoadMapToSuccessIMG}
            alt="A Proven Road Map To Success"
          />
          <img
            class="mobile"
            src={ProvenRoadMapToSuccessMobileIMG}
            alt="A Proven Road Map To Success"
          />
          <div className="brand-listing">
            <div className="item">
              <img src={NCAAIMG01} alt="ncaa" />
            </div>
            <div className="item">
              <img src={NAIAIMG01} alt="naia" />
            </div>
            <div className="item">
              <img src={CCCAA} alt="cccaa" />
            </div>
            <div className="item">
              <img src={NJCAAIMG01} alt="njcaa" />
            </div>
          </div>
        </div>
      </section>
      <section className="carrer-preferred-sec">
        <div className="container">
          <div className="top-block">
            <h3 className="sub-title">
              Take Charge of Your Recruiting Game Plan
            </h3>
          </div>
          <div className="preferred-list">
            <div className="item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60.354"
                  height="54.021"
                  viewBox="0 0 60.354 54.021"
                >
                  <path
                    id="_001-token"
                    data-name="001-token"
                    d="M14.066,37.6H54.545a2.072,2.072,0,0,1,2.066,2.066v4.186h3.52a6.3,6.3,0,1,1,0,4.247h-3.52v4.186a2.072,2.072,0,0,1-2.066,2.066H14.066A2.072,2.072,0,0,1,12,52.285V39.667A2.072,2.072,0,0,1,14.066,37.6ZM57.608,58.758l13.756,5.9V75.777A16.056,16.056,0,0,1,58.109,91.535l-.5.087-.5-.087A16.056,16.056,0,0,1,43.852,75.777V64.653Zm0,5.05L48.5,67.713v8.063a11.406,11.406,0,0,0,9.112,11.13,11.406,11.406,0,0,0,9.112-11.13V67.713ZM47.12,66.155a.987.987,0,0,0-.6.908l0,8.713A13.4,13.4,0,0,0,57.43,88.882a.982.982,0,0,0,.383-.005A13.4,13.4,0,0,0,68.7,75.777V67.063a.99.99,0,0,0-.666-.935l-10.038-4.3a.985.985,0,0,0-.773,0Zm4.519,10.055,3.319,3.319a1.482,1.482,0,0,0,2.1,0c2.844-2.844,3.7-3.734,6.527-6.593a1.478,1.478,0,1,0-2.1-2.085L56,76.383l-2.269-2.269a1.482,1.482,0,1,0-2.1,2.1Zm10.623-32.29a.993.993,0,0,1,.63.921V47.11a.993.993,0,0,1-.63.921,4.317,4.317,0,1,0,0-4.11Zm-14.133-.875v.542l-.383-.383a.989.989,0,0,0-1.4,1.4l.383.383h-.542a.989.989,0,0,0,0,1.979h.542l-.383.383a.989.989,0,0,0,1.4,1.4l.383-.383v.542a.989.989,0,0,0,1.979,0v-.542l.383.383a.989.989,0,1,0,1.4-1.4l-.383-.383h.542a.989.989,0,1,0,0-1.979h-.542l.383-.383a.989.989,0,0,0-1.4-1.4l-.383.383v-.542a.989.989,0,1,0-1.979,0Zm-25.864,4.3-.383-.383h.542a.989.989,0,1,0,0-1.979h-.542l.383-.383a.989.989,0,0,0-1.4-1.4l-.383.383v-.542a.989.989,0,0,0-1.979,0v.542L18.12,43.2a.989.989,0,0,0-1.4,1.4l.383.383h-.542a.989.989,0,1,0,0,1.979H17.1l-.383.383a.989.989,0,0,0,1.4,1.4l.383-.383v.542a.989.989,0,0,0,1.979,0v-.542l.383.383a.989.989,0,1,0,1.4-1.4Zm9.875,0-.383-.383H32.3a.989.989,0,1,0,0-1.979h-.542l.383-.383a.989.989,0,0,0-1.4-1.4l-.383.383v-.542a.989.989,0,0,0-1.979,0v.542L28,43.2a.989.989,0,0,0-1.4,1.4l.383.383h-.542a.989.989,0,1,0,0,1.979h.542l-.383.383a.989.989,0,1,0,1.4,1.4l.383-.383v.542a.989.989,0,0,0,1.979,0v-.542l.383.383a.989.989,0,1,0,1.4-1.4Zm9.875,0-.383-.383h.542a.989.989,0,1,0,0-1.979h-.542l.383-.383a.989.989,0,0,0-1.4-1.4l-.383.383v-.542a.989.989,0,0,0-1.979,0v.542L37.87,43.2a.989.989,0,0,0-1.4,1.4l.383.383h-.542a.989.989,0,0,0,0,1.979h.542l-.383.383a.989.989,0,0,0,1.4,1.4l.383-.383v.542a.989.989,0,0,0,1.979,0v-.542l.383.383a.989.989,0,0,0,1.4-1.4Z"
                    transform="translate(-12 -37.601)"
                    fill="#00b9ff"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
              <div className="detail-box">
                <p>
                  Access Key College Recruiting & Planning Tools & Resources
                </p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="59.051"
                  height="49.848"
                  viewBox="0 0 59.051 49.848"
                >
                  <g
                    id="_002-family"
                    data-name="002-family"
                    transform="translate(0 -39.898)"
                  >
                    <g
                      id="Group_57996"
                      data-name="Group 57996"
                      transform="translate(38.532 49.903)"
                    >
                      <g id="Group_57995" data-name="Group 57995">
                        <path
                          id="Path_85431"
                          data-name="Path 85431"
                          d="M354.533,131.267a4.651,4.651,0,0,0-4.641-4.618h-9.819a5.361,5.361,0,0,0-4.718,2.809l-.682,1.259a5.212,5.212,0,0,1-.588,5.084,5.166,5.166,0,0,1,1.98.58l2.739-5.054a.317.317,0,0,1,.6.151v32.651a2.354,2.354,0,0,0,4.707,0V145.317h1.016v18.812a2.354,2.354,0,0,0,4.707,0c0-30.393-.042-14.292-.043-32.832a.41.41,0,0,1,.821-.011l.072,14.409a1.961,1.961,0,0,0,1.961,1.951h.01a1.961,1.961,0,0,0,1.951-1.971Z"
                          transform="translate(-334.086 -126.649)"
                          fill="#00b9ff"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_57998"
                      data-name="Group 57998"
                      transform="translate(0 49.411)"
                    >
                      <g
                        id="Group_57997"
                        data-name="Group 57997"
                        transform="translate(0)"
                      >
                        <path
                          id="Path_85432"
                          data-name="Path 85432"
                          d="M41.441,137.2a3.357,3.357,0,0,0-3.35-3.333h-7.6a3.357,3.357,0,0,0-3.35,3.333c0,.572,0,.085-.016,2.78l-1.561-.321s-3.493-9.613-4.743-13.25c-.918-2.673-2.458-4.028-4.577-4.028H9.387c-2.119,0-3.659,1.355-4.577,4.028C3.386,130.553.154,139.4.121,139.485a1.98,1.98,0,0,0,3.718,1.36c.027-.075,2.349-6.426,3.934-10.914-.106.87.23-.961-2.812,14.742a1.1,1.1,0,0,0,1.08,1.31H7.552v14.36a2.376,2.376,0,1,0,4.751,0v-14.36h1.026v14.36a2.376,2.376,0,1,0,4.751,0v-14.36H19.59a1.1,1.1,0,0,0,1.08-1.31c-3.042-15.7-2.705-13.872-2.812-14.742,1.585,4.488,3.907,10.839,3.934,10.914a1.979,1.979,0,0,0,1.786,1.3l4.667.959a1.416,1.416,0,0,0,1.7-1.378s.024-3.976.026-4.447a.273.273,0,0,1,.546,0c0,3.815,0,22.146,0,23.733a1.7,1.7,0,0,0,3.4,0V147.434h.733V161.01a1.7,1.7,0,0,0,3.4,0c0-9.763-.024-21.243-.03-23.792a.3.3,0,0,1,.591,0l.052,10.4a1.415,1.415,0,0,0,1.415,1.408h.007a1.415,1.415,0,0,0,1.408-1.417s0,0,0-.006C41.482,145.439,41.45,139.145,41.441,137.2Z"
                          transform="translate(0 -122.383)"
                          fill="#00b9ff"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_58000"
                      data-name="Group 58000"
                      transform="translate(45.025 40.001)"
                    >
                      <g
                        id="Group_57999"
                        data-name="Group 57999"
                        transform="translate(0 0)"
                      >
                        <circle
                          id="Ellipse_4348"
                          data-name="Ellipse 4348"
                          cx="4.065"
                          cy="4.065"
                          r="4.065"
                          fill="#00b9ff"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_58002"
                      data-name="Group 58002"
                      transform="translate(30.613 52.303)"
                    >
                      <g id="Group_58001" data-name="Group 58001">
                        <circle
                          id="Ellipse_4349"
                          data-name="Ellipse 4349"
                          cx="3.691"
                          cy="3.691"
                          r="3.691"
                          fill="#00b9ff"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_58004"
                      data-name="Group 58004"
                      transform="translate(8.714 39.898)"
                    >
                      <g
                        id="Group_58003"
                        data-name="Group 58003"
                        transform="translate(0 0)"
                      >
                        <path
                          id="Path_85433"
                          data-name="Path 85433"
                          d="M79.651,39.9a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,79.651,39.9Z"
                          transform="translate(-75.548 -39.898)"
                          fill="#00b9ff"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div className="detail-box">
                <p>Finding the Right College Fit is a Major Family Decision</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60.012"
                  height="60.012"
                  viewBox="0 0 60.012 60.012"
                >
                  <g
                    id="_x31_8_Information"
                    transform="translate(-0.859 -0.859)"
                  >
                    <g
                      id="Group_58005"
                      data-name="Group 58005"
                      transform="translate(0.859 0.859)"
                    >
                      <path
                        id="Path_85434"
                        data-name="Path 85434"
                        d="M13.137,347.145a2.1,2.1,0,0,1,.361-2.765l1.062-.928a2.1,2.1,0,0,1-.521-2.526l-6.405,2.382A10.451,10.451,0,0,0,.859,353.06v4.47a3.417,3.417,0,0,0,3.414,3.414H22.5Z"
                        transform="translate(-0.859 -300.932)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85435"
                        data-name="Path 85435"
                        d="M252.377,343.284l-6.409-2.385a2.091,2.091,0,0,1-.514,2.526l1.069.931a2.1,2.1,0,0,1,.355,2.765l-9.363,13.8h18.227a3.416,3.416,0,0,0,3.411-3.414v-4.47A10.451,10.451,0,0,0,252.377,343.284Z"
                        transform="translate(-209.683 -300.908)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85436"
                        data-name="Path 85436"
                        d="M191.466,363.38c.832-2.552,1.684-5.309,2.382-7.933-.775-5.934-1.044-8.016-1.127-8.659l-.018-.122.508-.658-2.027-1.644-2.027,1.644.5.646-1.139,8.775v0c.744,2.752,1.5,5.222,2.391,7.955a.908.908,0,0,1-.006.591h.57A.928.928,0,0,1,191.466,363.38Z"
                        transform="translate(-166.447 -303.965)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85437"
                        data-name="Path 85437"
                        d="M178.858,318.575a37.059,37.059,0,0,0,.444-6.626l-.19.089-4.691,2.2c-2.691-1.258-4.134-1.935-4.89-2.287a37.04,37.04,0,0,0,.444,6.629l4.443-3.607Z"
                        transform="translate(-149.682 -275.363)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85438"
                        data-name="Path 85438"
                        d="M131.3,101.82l-1.684-1.47.4-.23a1.489,1.489,0,0,0,.159-2.471l-4.487-3.418a19.3,19.3,0,0,1-.317-3.293,20.6,20.6,0,0,0,2.872-5.88h0a2.85,2.85,0,0,0,2.373-2.465c.267-1.154.059-2.628-.925-3.218.107-.386.208-.766.3-1.151,1.372-5.854-.285-9.486-5.367-11.773-2.6-1.17-6.286-1.831-9.109,1.656l-.064.083c-.055-.009-.125-.024-.19-.037-3.316-.649-5.429.6-6.28,3.72-.514,1.889-.086,5.239.53,7.508a2.947,2.947,0,0,0-.922,3.215,2.864,2.864,0,0,0,2.367,2.459,20.662,20.662,0,0,0,2.876,5.883,19.309,19.309,0,0,1-.312,3.288l-4.483,3.419a1.487,1.487,0,0,0,.153,2.474l.4.23-1.684,1.47a1.488,1.488,0,0,0-.254,1.96l9.5,14.008a.306.306,0,0,0,.254.135h1.044a.305.305,0,0,0,.291-.4c-2.275-6.981-4.89-15.843-4.639-23.086a17.37,17.37,0,0,0,.312-2.71,5.543,5.543,0,0,0,4.161,1.9h2.042a5.544,5.544,0,0,0,4.159-1.9,17.5,17.5,0,0,0,.315,2.691c.254,7.19-2.353,16.118-4.63,23.1a.3.3,0,0,0,.291.4H121.8a.3.3,0,0,0,.251-.135l9.507-14.008a1.483,1.483,0,0,0-.254-1.959Zm-6.693-10.857a4.929,4.929,0,0,1-3.986,2.054h-2.042a4.943,4.943,0,0,1-4.132-2.261h0a19.643,19.643,0,0,1-2.961-6.1.3.3,0,0,0-.3-.233.334.334,0,0,0-.055,0c-.787.147-1.656-.738-1.947-1.972a2.478,2.478,0,0,1,.505-2.45c.234.714.558,1.634,1.384,1.644h.012c.83,0,.958-.9,1.05-1.549l.006-.04c.258-1.773.959-3.088.478-4.743a.214.214,0,0,1,.116-.26,8.082,8.082,0,0,0,3.025-2.076.227.227,0,0,1,.162-.077.259.259,0,0,1,.171.077c1.966,2.079,6.883,3.582,9.819,2.37a.219.219,0,0,1,.285.227c-.067,1.783.6,2.89,1.111,4.936a1.169,1.169,0,0,0,1.093.824.993.993,0,0,0,.968-.8c.06-.214.135-.481.147-.536a2.592,2.592,0,0,1,.5,2.45c-.291,1.24-1.163,2.128-1.954,1.975a.307.307,0,0,0-.355.227A19.771,19.771,0,0,1,124.607,90.962Z"
                        transform="translate(-94.864 -57.91)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85439"
                        data-name="Path 85439"
                        d="M330.92.859c-6.213,0-11.265,4-11.265,8.91a8.189,8.189,0,0,0,3.644,6.565,12.093,12.093,0,0,1-2.847,3.322.79.79,0,0,0,.588,1.4,16.768,16.768,0,0,0,7.434-2.587,14.04,14.04,0,0,0,2.446.211c6.206,0,11.255-4,11.255-8.91S337.126.859,330.92.859Zm1.624,13.888a1.782,1.782,0,1,1-3.564,0V9.582a1.782,1.782,0,1,1,3.564,0Zm-1.785-7.994a1.871,1.871,0,1,1,1.875-1.868A1.87,1.87,0,0,1,330.759,6.753Z"
                        transform="translate(-282.163 -0.859)"
                        fill="#00b9ff"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div className="detail-box">
                <p>Access Expert Guidance to Answer Your Key Questions</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="46.286"
                  height="59.542"
                  viewBox="0 0 46.286 59.542"
                >
                  <g
                    id="_004-road-map"
                    data-name="004-road-map"
                    transform="translate(-6.4 -1)"
                  >
                    <g
                      id="Group_58006"
                      data-name="Group 58006"
                      transform="translate(6.4 1)"
                    >
                      <path
                        id="Path_85440"
                        data-name="Path 85440"
                        d="M42.4,13.884a7.581,7.581,0,0,1-2.5-2.377c-2.627-.5-18.013-3.753-18.513-3.878-.375-.125-.375-.125-.5-.25h-.125s-.125.125-.125,0c-.125,0,.25-.25.751-.375,1.251-.375,3.878-.876,3.628-2.752-.125-1.751-2.252-2.5-4.128-2.627-.125,0-5.629-.375-5.629-.375l-4-.25c-.25,0-.5.125-.5.375s.125.5.375.5c10.257,1.5,10.382,1.5,10.758,1.751.25.125.25.375.25.25-1,.5-4.753.375-5.129,2.752-.5,3.377,3,3.878,19.764,9.131.751.25,1,1.126.375,1.376-5,2.377-12.134,2.752-18.513,6a96.808,96.808,0,0,1-4.5,9.507,1.835,1.835,0,0,1-3.252,0c-.25-.5-.625-1.126-.876-1.751a24.059,24.059,0,0,0-1.5,3.127,18.018,18.018,0,0,0-1,6.88,24.019,24.019,0,0,0,1.376,6.755,40.44,40.44,0,0,0,6.755,11.508,6.556,6.556,0,0,0,1.251,1.376H28.77c-.375-.375-.876-.625-1.251-1a.354.354,0,0,1,.5-.5A13.294,13.294,0,0,1,29.4,60.167c.125.125.125.125.125.25H43.03c-.876-1-1.876-2-2.752-2.877l-.125.25a2.024,2.024,0,0,1-3.628,0l-2.5-5.379a6.5,6.5,0,0,1-2.377-2.127Q29.4,48.6,27.519,46.907a27.123,27.123,0,0,1-4.878-5.379,7.115,7.115,0,0,1-1.376-4.5,7.669,7.669,0,0,1,2.377-4.378A20.707,20.707,0,0,1,29.4,29.02c4.5-2.127,10.633-3.628,15.011-7.755a7.268,7.268,0,0,0,1.751-2.252c-.625.5-1.751-1.5-3.753-5.129Zm-22.266-5a.38.38,0,0,1-.5,0,1.7,1.7,0,0,1-.625-2,.24.24,0,0,1,.375-.125c.125.125.25.25.125.375a1.053,1.053,0,0,0,.375,1.251c.375.25.375.375.25.5Zm-4.5,30.647a13.614,13.614,0,0,1,.375-3.878c0-.125.25-.25.375-.25s.25.25.25.375a15.788,15.788,0,0,0-.375,3.753c0,.125-.125.375-.25.375Q15.636,39.715,15.636,39.527Zm1.626,6.5c-.125,0-.375,0-.375-.125a20.842,20.842,0,0,1-1-3.753c0-.125.125-.375.25-.375s.375.125.375.25a22.711,22.711,0,0,0,1,3.628c0,.125,0,.25-.25.375Zm-.125-12.384c-.125-.125-.25-.25-.125-.375a17.674,17.674,0,0,1,2.5-3,.354.354,0,1,1,.5.5,12.057,12.057,0,0,0-2.377,2.877.38.38,0,0,1-.5,0ZM19.263,49.91a.24.24,0,0,1-.375-.125,10.339,10.339,0,0,1-.876-1.626.28.28,0,0,1,.5-.25c.25.5.625,1.126.876,1.626A.46.46,0,0,1,19.263,49.91Zm3.5,4.878a.38.38,0,0,1,.5,0c.876,1,1.751,1.876,2.752,2.877a.38.38,0,0,1,0,.5c-.125.125-.375.125-.375,0a29.228,29.228,0,0,1-2.752-2.877C22.64,55.038,22.64,54.913,22.766,54.788Zm-1.251-2c.125.125.125.375,0,.375a.38.38,0,0,1-.5,0l-1.126-1.5a.28.28,0,0,1,.5-.25,13.293,13.293,0,0,1,1.126,1.376Zm3.5-25.768a33.858,33.858,0,0,0-3.127,2.127c-.125.125-.375.125-.375,0-.125-.125-.125-.375,0-.375a36.728,36.728,0,0,1,3.252-2.127.24.24,0,0,1,.375.125c.125,0,0,.125-.125.25Zm5.629-2.877a28.639,28.639,0,0,0-3.377,1.751.28.28,0,1,1-.25-.5c1.126-.625,2.252-1.126,3.377-1.751a.24.24,0,0,1,.375.125C30.9,23.891,30.771,24.016,30.646,24.141Zm5.754-2.5c-1.251.5-2.377,1-3.5,1.5-.125,0-.375,0-.375-.125s0-.375.125-.375c1.126-.5,2.377-1,3.5-1.5.125,0,.375,0,.375.125C36.65,21.389,36.65,21.515,36.4,21.64ZM25.768,10.882c-1.751-.375-2.5-.375-3.753-.751-.125-.125-.25-.25-.125-.375,0-.125.25-.25.375-.25a21.969,21.969,0,0,0,3.753.751c.125,0,.25.25.25.375A.65.65,0,0,1,25.768,10.882Zm6.254,1.376c-1.126-.25-2.377-.625-3.753-.876-.125,0-.25-.25-.25-.375s.25-.25.375-.25c1.251.25,2.5.625,3.753.876.125,0,.25.25.25.375C32.4,12.258,32.147,12.383,32.022,12.258Zm6,1.876c-1-.375-2.252-.751-3.628-1.126-.125,0-.25-.25-.25-.375s.25-.25.375-.25c1.376.375,2.627.751,3.628,1.126.125,0,.25.25.25.375C38.4,14.134,38.277,14.134,38.026,14.134Zm4.5,5.254c-.5.375-.5.125-3.628,1.376-.125,0-.375,0-.375-.25,0-.125,0-.375.25-.375,2-.751,3.252-1.126,3.252-1.126a.437.437,0,0,1,.25-.125.24.24,0,0,1,.375.125A.46.46,0,0,1,42.53,19.388Zm1-2c-.125,0-.375,0-.375-.125-.125-.5-.751-1.251-2.752-2.127a.28.28,0,0,1,.25-.5c1.751.876,2.752,1.626,3.127,2.5A.245.245,0,0,1,43.53,17.387Z"
                        transform="translate(-6.129 -1)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85441"
                        data-name="Path 85441"
                        d="M13.28,30.139c1.5-2.877,5.629-11.133,5.629-13.885A6.273,6.273,0,0,0,12.654,10,6.194,6.194,0,0,0,6.4,16.254c0,2.877,4.128,11.008,5.629,13.885C12.4,30.515,13.155,30.515,13.28,30.139ZM9.027,16.254a3.753,3.753,0,1,1,7.505,0,3.686,3.686,0,0,1-3.753,3.753A3.763,3.763,0,0,1,9.027,16.254Z"
                        transform="translate(-6.4 1.258)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85442"
                        data-name="Path 85442"
                        d="M38.374,1.431a6.326,6.326,0,0,0-4.753,4.878,6.3,6.3,0,0,0,3.252,6.755l2.252,4.878a.61.61,0,0,0,1.126,0L42.5,13.064a6.184,6.184,0,0,0,3.377-5.5,6.1,6.1,0,0,0-7.505-6.129Zm1.376,9.757A3.763,3.763,0,0,1,36,7.435a3.753,3.753,0,1,1,7.505,0A3.686,3.686,0,0,1,39.75,11.188Z"
                        transform="translate(0.404 -0.93)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Path_85443"
                        data-name="Path 85443"
                        d="M32.054,30.934a7.212,7.212,0,0,0-5.629,5.754A7.3,7.3,0,0,0,30.3,44.569l2.752,5.754a.739.739,0,0,0,1.376,0l2.752-5.754a7.3,7.3,0,0,0,4-6.5A7.507,7.507,0,0,0,32.054,30.934Zm1.626,11.508a4.378,4.378,0,1,1,4.378-4.378A4.432,4.432,0,0,1,33.681,42.443Z"
                        transform="translate(-1.408 6.467)"
                        fill="#00b9ff"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div className="detail-box">
                <p>Follow Our Step-by-Step Recruiting Road Map</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="59.577"
                  height="59.577"
                  viewBox="0 0 59.577 59.577"
                >
                  <path
                    id="_005-time"
                    data-name="005-time"
                    d="M24.09,55.786a2.34,2.34,0,0,1-.358-.028,28.044,28.044,0,1,1,32.1-31.517,2.327,2.327,0,0,1-4.612.626A23.39,23.39,0,1,0,24.442,51.158a2.327,2.327,0,0,1-.352,4.628Zm-3-17.379L29.7,29.679a2.327,2.327,0,0,0,.671-1.635V10.707a2.327,2.327,0,0,0-4.654,0V27.09l-7.94,8.047a2.327,2.327,0,0,0,3.313,3.269Zm38.449,8.329a2.327,2.327,0,0,0-4.577-.845,11.045,11.045,0,1,1-7.889-12.669,2.327,2.327,0,1,0,1.252-4.483,15.71,15.71,0,1,0,11.214,18ZM46.962,47.909,57.131,37.844a2.327,2.327,0,0,0-3.274-3.308L44.1,44.194l-3.017-3.017a2.327,2.327,0,0,0-3.291,3.291l3.427,3.427a4.081,4.081,0,0,0,5.745.015Z"
                    transform="translate(0 -0.002)"
                    fill="#00b9ff"
                  />
                </svg>
              </div>
              <div className="detail-box">
                <p>Save Tens of Hours of Time & streamline your college plan</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60.75"
                  height="60.753"
                  viewBox="0 0 60.75 60.753"
                >
                  <g id="Page-1" transform="translate(0 0)">
                    <g
                      id="_059---Money-Bag"
                      data-name="059---Money-Bag"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Shape"
                        d="M15.934,22.769A12.354,12.354,0,0,1,9.967,24.1,12.354,12.354,0,0,1,4,22.769v24.2a16.1,16.1,0,0,1,1.627-.081,12.355,12.355,0,0,1,5.967,1.335V40.378c0-1.736,1.718-3.163,4.339-3.868Z"
                        transform="translate(0.339 1.932)"
                        fill="#00b9ff"
                      />
                      <ellipse
                        id="Oval"
                        cx="5.967"
                        cy="2.17"
                        rx="5.967"
                        ry="2.17"
                        transform="translate(0 50.989)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-2"
                        data-name="Shape"
                        d="M0,51.769v2.42c0,.868,2.379,2.17,5.967,2.17s5.967-1.3,5.967-2.17v-2.42A12.355,12.355,0,0,1,5.967,53.1,12.355,12.355,0,0,1,0,51.769Z"
                        transform="translate(0 4.393)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-3"
                        data-name="Shape"
                        d="M29.813,9.9a4.674,4.674,0,0,0,2.781.936,23.481,23.481,0,0,1-2.216-5.126,1.085,1.085,0,0,1,2.091-.583A20.09,20.09,0,0,0,35.2,10.849H36.32a19.9,19.9,0,0,0,2.736-5.715,1.085,1.085,0,0,1,2.092.581,23.465,23.465,0,0,1-2.214,5.122A4.653,4.653,0,0,0,41.656,9.9c2.54-1.985,3.43-5.142,3.723-7.442a1,1,0,0,0-.463-.994,1.127,1.127,0,0,0-1.231,0,4.593,4.593,0,0,1-2.54.7A4.892,4.892,0,0,1,37.76.846a2.855,2.855,0,0,0-4.057,0A4.9,4.9,0,0,1,30.317,2.17a4.571,4.571,0,0,1-2.528-.7,1.151,1.151,0,0,0-.614-.181,1.168,1.168,0,0,0-.623.182.992.992,0,0,0-.461.99c.3,2.3,1.184,5.455,3.721,7.44Z"
                        transform="translate(2.214 0)"
                        fill="#00b9ff"
                      />
                      <ellipse
                        id="Oval-2"
                        data-name="Oval"
                        cx="5.967"
                        cy="2.17"
                        rx="5.967"
                        ry="2.17"
                        transform="translate(10.849 4.339)"
                        fill="#00b9ff"
                      />
                      <ellipse
                        id="Oval-3"
                        data-name="Oval"
                        cx="5.967"
                        cy="2.17"
                        rx="5.967"
                        ry="2.17"
                        transform="translate(4.339 19.527)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-4"
                        data-name="Shape"
                        d="M59.055,34.22C55.524,19.237,46.1,13.108,43.232,11.556a6.854,6.854,0,0,1-1.663.559l2.015,1.88A1.085,1.085,0,1,1,42.1,15.582l-3.543-3.308h-.347v3.255a1.085,1.085,0,0,1-2.17,0V12.274H35.7l-3.543,3.308a1.086,1.086,0,0,1-1.482-1.587l2-1.869A6.877,6.877,0,0,1,31,11.569a28.519,28.519,0,0,0-7.2,5.77c-.009.009-.016.018-.025.028a32.889,32.889,0,0,0-2.233,2.718A1.085,1.085,0,0,1,19.792,18.8c.708-.966,1.428-1.837,2.142-2.636v-7.4A12.354,12.354,0,0,1,15.967,10.1,12.354,12.354,0,0,1,10,8.769v7.859c4.364.14,7.594,1.953,7.594,4.325V37.308a16.1,16.1,0,0,1,1.627-.081c4.638,0,8.137,1.866,8.137,4.339V53.5H47.092c1.134,0,6.962-.217,10.319-4.448,2.625-3.32,3.179-8.309,1.644-14.831Zm-16.508-.248a4.339,4.339,0,0,1-4.339,4.339V39.4a1.085,1.085,0,0,1-2.17,0V38.311A4.339,4.339,0,0,1,31.7,33.972a1.085,1.085,0,0,1,2.17,0,2.17,2.17,0,0,0,2.17,2.17V31.8a4.339,4.339,0,1,1,0-8.679V22.038a1.085,1.085,0,0,1,2.17,0v1.085a4.339,4.339,0,0,1,4.339,4.339,1.085,1.085,0,0,1-2.17,0,2.17,2.17,0,0,0-2.17-2.17v4.339A4.339,4.339,0,0,1,42.546,33.972ZM55.711,47.7c-2.738,3.456-7.66,3.631-8.619,3.631a1.085,1.085,0,1,1,0-2.17c.784,0,4.8-.136,6.917-2.809a8.308,8.308,0,0,0,1.526-4.839,1.1,1.1,0,0,1,1.136-1.032A1.085,1.085,0,0,1,57.7,41.617,10.415,10.415,0,0,1,55.711,47.7Z"
                        transform="translate(0.849 0.744)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-5"
                        data-name="Shape"
                        d="M32,26.17a2.17,2.17,0,0,0,2.17,2.17V24A2.17,2.17,0,0,0,32,26.17Z"
                        transform="translate(2.716 2.037)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-6"
                        data-name="Shape"
                        d="M36,34.339A2.17,2.17,0,0,0,36,30Z"
                        transform="translate(3.055 2.546)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-7"
                        data-name="Shape"
                        d="M13,41.769v11.1c0,.868,2.379,2.17,5.967,2.17s5.967-1.3,5.967-2.17v-11.1A12.354,12.354,0,0,1,18.967,43.1,12.355,12.355,0,0,1,13,41.769Z"
                        transform="translate(1.103 3.545)"
                        fill="#00b9ff"
                      />
                      <ellipse
                        id="Oval-4"
                        data-name="Oval"
                        cx="5.967"
                        cy="2.17"
                        rx="5.967"
                        ry="2.17"
                        transform="translate(14.103 40.14)"
                        fill="#00b9ff"
                      />
                      <path
                        id="Shape-8"
                        data-name="Shape"
                        d="M48.15,7.4c0,1.779-1.931,3.233-4.339,3.255a5.533,5.533,0,0,1-1.2-.13.815.815,0,0,1-.206.184c.174.108.369.228.575.347.662.434,1.432.966,2.278,1.627.087.065.163.13.25.206,5.4.4,7.117,2.658,7.171,2.723a1.085,1.085,0,0,0,.9.466,1.019,1.019,0,0,0,.6-.184,1.085,1.085,0,0,0,.3-1.5c-.087-.13-1.584-2.278-5.956-3.265A4.96,4.96,0,0,0,50.32,7.4,5.6,5.6,0,0,0,46.165,2.33a1.471,1.471,0,0,1-.022.217,16.635,16.635,0,0,1-.369,1.964A3.314,3.314,0,0,1,48.15,7.4Z"
                        transform="translate(3.599 0.198)"
                        fill="#00b9ff"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div className="detail-box">
                <p>Avoid Money Grab Showcases Maximize Your Recruiting ROI</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CoachTestimonials />
      <section className="athlete-common-sec athlete-home-ls">
        <div className="common-listing">
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">Data-Driven Profile</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>Complete Athletic & Academic Profile</li>
                      <li>Add Your Stats (Blast, Trackman, Rapsodo)</li>
                      <li>Get Your Stats Verified</li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeSuccessIMG01}
                          alt="Patrick Herrera - Northwestern"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeSuccessLogoIMG01}
                            alt="Patrick Herrera - Northwestern"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Patrick Herrera - Northwestern</h4>
                        <p>
                          SportsForce got my name out there and helped me
                          eventually find my perfect school
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img
                    src={DataDrivenProfileMockupIMG01}
                    alt="Data-Driven Profile"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">College Search System</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>Proprietary Athletic & Academic Grouping</li>
                      <li>Easily Search & Compare Colleges</li>
                      <li>Find Your Top College Matches</li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeSuccessIMG02}
                          alt="Jake Dunagan - Davidson"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeSuccessLogoIMG02}
                            alt="Jake Dunagan - Davidson"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Jake Dunagan - Davidson</h4>
                        <p>
                          Jake received recruiting active interest from more
                          than 8 different division 1 programs
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img
                    src={CollegeSearchSystemMockupIMG01}
                    alt="College Search System"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">Get Verified</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>
                        Submit Your Stats (Blast, Trackman, Rapsodo, etc..)
                      </li>
                      <li>Get Verified by Our Staff</li>
                      <li>Promote Yourself to College Coaches</li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeStoriesIMG03}
                          alt="Jamir Gibson - Grambling"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeStoriesLogoIMG03}
                            alt="Jamir Gibson - Grambling"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Jamir Gibson - Grambling</h4>
                        <p>
                          If you’re serious about college baseball SportsForce
                          is who you want on your side!!!
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img src={GetVerifiedMockupIMG01} alt="Get Verified" />
                </div>
              </div>
            </div>
          </div>
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">Message Coaches</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>Easily Email, DM, or Call</li>
                      <li>Save Tens of Hours</li>
                      <li>Every DI, DII, DIII, NAIA & JC</li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeSuccessIMG04}
                          alt="Ethan Ezor - Colorado Mesa"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeStoriesLogoIMG04}
                            alt="Ethan Ezor - Colorado Mesa"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Ethan Ezor - Colorado Mesa</h4>
                        <p>
                          SportsForce helped me get on the map with various
                          schools and get my name out there
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img src={MesssageCoachesMockupIMG01} alt="Message Coaches" />
                </div>
              </div>
            </div>
          </div>
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">Resource Center</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>World-Class Educational Library</li>
                      <li>How-to-Videos & FAQ’s</li>
                      <li>Masterclasses (Athletic & Academic)</li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeSuccessIMG05}
                          alt="Matt McNaney - Trinity"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeSuccessLogoIMG05}
                            alt="Matt McNaney - Trinity"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Matt McNaney - Trinity</h4>
                        <p>
                          SportsForce was so helpful tracking which schools were
                          answering and watching my video
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img src={ResourceCenterMockupIMG01} alt="Resource Center" />
                </div>
              </div>
            </div>
          </div>
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">Activity Feed</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>
                        Find schools that fit your athletic and academic goals.
                      </li>
                      <li>
                        Filter schools by location, division, test scores, etc.
                      </li>
                      <li>
                        Build your target list of schools with the click of a
                        button.
                      </li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeSuccessIMG06}
                          alt="Vincent Venverloh - USD"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeSuccessLogoIMG06}
                            alt="Vincent Venverloh - USD"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Vincent Venverloh - USD</h4>
                        <p>
                          The coaches helping are very knowledgeable, have many
                          useful college connections.
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img src={ActivityFeedMockupIMG01} alt="Activity Feed" />
                </div>
              </div>
            </div>
          </div>
          <div className="common-listing-item">
            <div className="container">
              <div className="item-row">
                <div className="content-box">
                  <div className="top-block">
                    <h3 className="title">Personalized Checklist</h3>
                  </div>
                  <div className="detail-text">
                    <ul>
                      <li>Easily Get-on-Track</li>
                      <li>Stay Accountable</li>
                      <li>Complete Key Action Items</li>
                    </ul>
                    <div className="success-info-box">
                      <div className="pick-box">
                        <img
                          className="pick-img"
                          src={HomeSuccessIMG07}
                          alt="Markinson - Northwestern"
                        />
                        <span className="icon-box">
                          <img
                            src={HomeSuccessLogoIMG01}
                            alt="Markinson - Northwestern"
                          />
                        </span>
                      </div>
                      <div className="detail-info-box">
                        <h4 className="name">Markinson - Northwestern</h4>
                        <p>
                          I am super excited for the next 4 years! My advisor
                          Ryan Thompson, was super helpful.
                        </p>
                        <p className="star-rating-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.658"
                            height="16.923"
                            viewBox="0 0 17.658 16.923"
                          >
                            <path
                              id="__TEMP__SVG__"
                              d="M18.928,10.107a1.188,1.188,0,0,0-.687-2.14l-4.794-.182a.123.123,0,0,1-.107-.08L11.683,3.212a1.181,1.181,0,0,0-2.221,0L7.811,7.722A.123.123,0,0,1,7.7,7.8L2.91,7.984a1.188,1.188,0,0,0-.687,2.14l3.761,2.969a.123.123,0,0,1,.043.128L4.731,17.827a1.184,1.184,0,0,0,1.8,1.311l3.974-2.675a.117.117,0,0,1,.133,0l3.974,2.675a1.169,1.169,0,0,0,1.8-1.284l-1.305-4.622a.118.118,0,0,1,.043-.128Z"
                              transform="translate(-1.746 -2.432)"
                              fill="#ffce30"
                            />
                          </svg>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="img-box">
                  <img
                    src={PersonalizedCheckListMockupIMG01}
                    alt="Personalized Checklist"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="athlete-coachinfo-sec">
        <div className="container">
          <div className="top-block">
            <h2 className="title">
              College Search, Coach Connections, Stats & Video All-In-One
              Platform.
            </h2>
          </div>
          <div className="coachinfo-list">
            <div className="item">
              <div className="coach-cartbox">
                <div className="title-info">
                  <h3 className="title">
                    Private Messaging <br />
                    (COMING SOON)
                  </h3>
                  <div className="iconbox">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42.913"
                      height="30.938"
                      viewBox="0 0 42.913 30.938"
                    >
                      <path
                        id="email"
                        d="M41.169,6.75H5.244A2.994,2.994,0,0,0,2.25,9.744v23.95a2.994,2.994,0,0,0,2.994,2.994H41.169a2.994,2.994,0,0,0,2.994-2.994V9.744A2.994,2.994,0,0,0,41.169,6.75ZM37.876,9.744,23.206,19.892,8.537,9.744ZM5.244,33.694V11.106l17.11,11.841a1.5,1.5,0,0,0,1.706,0l17.11-11.841V33.694Z"
                        transform="translate(-1.75 -6.25)"
                        fill="#fff"
                        stroke="#00b9ff"
                        stroke-width="1"
                      />
                    </svg>
                  </div>
                </div>
                <p>
                  Our Coach trusted message center assures college coaches can
                  connect with prospects like you.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="coach-cartbox">
                <div className="title-info">
                  <h3 className="title">
                    College <br />
                    Search
                  </h3>
                  <div className="iconbox">
                    <svg
                      id="_002-search"
                      data-name="002-search"
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <path
                        id="Path_83970"
                        data-name="Path 83970"
                        d="M16.534,30.067a13.533,13.533,0,0,0,9.57-23.1A13.534,13.534,0,1,0,6.964,26.1,13.447,13.447,0,0,0,16.534,30.067ZM7.833,7.833a12.3,12.3,0,1,1-3.6,8.7,12.225,12.225,0,0,1,3.6-8.7Z"
                        transform="translate(-0.034 -0.033)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83971"
                        data-name="Path 83971"
                        d="M16.406,32.811a16.279,16.279,0,0,0,10.123-3.5l2.078,2.078-.464.464a.656.656,0,0,0,0,.928L36.4,41.039a3.281,3.281,0,1,0,4.64-4.638h0l-8.256-8.258a.656.656,0,0,0-.928,0l-.465.465-2.078-2.078a16.4,16.4,0,1,0-12.906,6.283Zm23.7,7.3a2.014,2.014,0,0,1-2.783,0l-7.792-7.792L30,31.856h0L31.852,30l0,0,0,0,.462-.463,7.792,7.794h0a1.966,1.966,0,0,1,0,2.783ZM30.462,29.535l-.927.929-2-2c.16-.148.32-.3.476-.452s.3-.315.452-.476ZM5.733,5.733A15.094,15.094,0,1,1,27.079,27.078,15.094,15.094,0,0,1,5.733,5.733Z"
                        transform="translate(0 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83972"
                        data-name="Path 83972"
                        d="M13.611,26.572a1.983,1.983,0,0,0,1.98,1.98h7.92a1.984,1.984,0,0,0,1.981-1.981V21.988l3.3-1.1v3.043a.66.66,0,1,0,1.32,0V19.972h0s0,0,0,0a.672.672,0,0,0-.046-.227.685.685,0,0,0-.038-.073.615.615,0,0,0-.083-.123.666.666,0,0,0-.064-.065.646.646,0,0,0-.117-.079.59.59,0,0,0-.084-.043c-.007,0-.013-.009-.02-.011l-9.9-3.3a.665.665,0,0,0-.418,0l-9.9,3.3a.659.659,0,0,0,0,1.251l4.169,1.389v4.585Zm10.561,0a.662.662,0,0,1-.659.661H15.591a.66.66,0,0,1-.66-.66V22.428L19.343,23.9a.651.651,0,0,0,.417,0l4.412-1.471Zm-4.621-9.2L25.38,19.31H19.551a.66.66,0,1,0,0,1.32h5.837l-5.837,1.946-7.813-2.6Z"
                        transform="translate(-3.056 -5.53)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </div>
                <p>
                  Find colleges that best fit your academic, athletic,
                  financial, geographical, and personal goals.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="coach-cartbox">
                <div className="title-info">
                  <h3 className="title">
                    Target List of <br />
                    Colleges
                  </h3>
                  <div className="iconbox">
                    <svg
                      id="_003-target"
                      data-name="003-target"
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <path
                        id="Path_83973"
                        data-name="Path 83973"
                        d="M15.61,21.331a14.3,14.3,0,0,1-7.373-2.189A2.576,2.576,0,0,1,7,16.929V11.861a.861.861,0,0,1,1.722,0v5.068a.863.863,0,0,0,.394.735,11.763,11.763,0,0,0,12.985,0,.86.86,0,0,0,.4-.735V11.861a.861.861,0,0,1,1.722,0v5.068a2.576,2.576,0,0,1-1.236,2.214A14.3,14.3,0,0,1,15.61,21.331Z"
                        transform="translate(5.39 8.353)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83974"
                        data-name="Path 83974"
                        d="M17.39,19.054a.907.907,0,0,1-.372-.079L5.513,13.809a.852.852,0,0,1,0-1.563L17.019,7.08a.9.9,0,0,1,.743,0l11.505,5.166a.852.852,0,0,1,0,1.563L17.762,18.975a.907.907,0,0,1-.372.079ZM8,13.027l9.394,4.217,9.394-4.217L17.39,8.81Z"
                        transform="translate(3.61 5.331)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83975"
                        data-name="Path 83975"
                        d="M19.917,38.334A18.417,18.417,0,1,1,38.334,19.917,18.437,18.437,0,0,1,19.917,38.334Zm0-35.08A16.663,16.663,0,1,0,36.58,19.917,16.683,16.683,0,0,0,19.917,3.254Z"
                        transform="translate(1.083 1.083)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83976"
                        data-name="Path 83976"
                        d="M12.361,6.888a.861.861,0,0,1-.861-.861V.861a.861.861,0,0,1,1.722,0V6.027A.861.861,0,0,1,12.361,6.888Z"
                        transform="translate(8.639)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83977"
                        data-name="Path 83977"
                        d="M12.361,26.888a.861.861,0,0,1-.861-.861V20.861a.861.861,0,1,1,1.722,0v5.166A.861.861,0,0,1,12.361,26.888Z"
                        transform="translate(8.639 15.112)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83978"
                        data-name="Path 83978"
                        d="M26.027,13.222H20.861a.861.861,0,1,1,0-1.722h5.166a.861.861,0,0,1,0,1.722Z"
                        transform="translate(15.112 8.639)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83979"
                        data-name="Path 83979"
                        d="M6.027,13.222H.861a.861.861,0,0,1,0-1.722H6.027a.861.861,0,0,1,0,1.722Z"
                        transform="translate(0 8.639)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </div>
                <p>
                  Easily Favorite & Track Your Recruiting Progress For Each
                  College
                </p>
              </div>
            </div>
            <div className="item">
              <div className="coach-cartbox">
                <div className="title-info">
                  <h3 className="title">
                    Unlimited <br />
                    Video
                  </h3>
                  <div className="iconbox">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43.5"
                      height="43.5"
                      viewBox="0 0 43.5 43.5"
                    >
                      <path
                        id="_005-video-tutorial"
                        data-name="005-video-tutorial"
                        d="M29.667,13.01,16.761,8.2a1.641,1.641,0,0,0-2.214,1.537v9.625A1.642,1.642,0,0,0,16.761,20.9l12.906-4.813A1.642,1.642,0,0,0,29.667,13.01ZM17.828,17V12.1l6.57,2.45ZM37.078,0H4.922A4.927,4.927,0,0,0,0,4.922v19.25a4.927,4.927,0,0,0,4.922,4.922H37.078A4.927,4.927,0,0,0,42,24.172V4.922A4.927,4.927,0,0,0,37.078,0Zm1.641,24.172a1.642,1.642,0,0,1-1.641,1.641H4.922a1.642,1.642,0,0,1-1.641-1.641V4.922A1.642,1.642,0,0,1,4.922,3.281H37.078a1.642,1.642,0,0,1,1.641,1.641Zm-1.586,11.32h-5.1a4.867,4.867,0,0,0-9.164,0h-18a1.641,1.641,0,0,0,0,3.281h18a4.867,4.867,0,0,0,9.164,0h5.1a1.641,1.641,0,0,0,0-3.281Zm-9.68,3.227a1.586,1.586,0,1,1,1.586-1.586A1.588,1.588,0,0,1,27.453,38.719Z"
                        transform="translate(0.75 0.75)"
                        fill="#fff"
                        stroke="#00b9ff"
                        stroke-width="1.5"
                      />
                    </svg>
                  </div>
                </div>
                <p>
                  Any Device. Any Source. - Phone, Computer, & Tablet. -
                  YouTube, HUDL, & Vimeo
                </p>
              </div>
            </div>
            <div className="item">
              <div className="coach-cartbox">
                <div className="title-info">
                  <div className="title">
                    Activity <br />
                    Feed
                  </div>
                  <div className="iconbox">
                    <svg
                      id="_007-opinion"
                      data-name="007-opinion"
                      xmlns="http://www.w3.org/2000/svg"
                      width="40.113"
                      height="42"
                      viewBox="0 0 40.113 42"
                    >
                      <path
                        id="Path_83983"
                        data-name="Path 83983"
                        d="M63.488,344.638a3.718,3.718,0,0,1-3.5,0,.615.615,0,0,0-.592,1.079,4.947,4.947,0,0,0,4.683,0,.616.616,0,1,0-.594-1.079Zm0,0"
                        transform="translate(-54.232 -316.298)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83984"
                        data-name="Path 83984"
                        d="M70.914,313.588a.615.615,0,1,1-.615-.615A.616.616,0,0,1,70.914,313.588Zm0,0"
                        transform="translate(-63.966 -287.3)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83985"
                        data-name="Path 83985"
                        d="M99.547,313.588a.615.615,0,1,1-.615-.615A.615.615,0,0,1,99.547,313.588Zm0,0"
                        transform="translate(-90.251 -287.3)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83986"
                        data-name="Path 83986"
                        d="M39.267,286.065a.615.615,0,1,0-1.091.569,6.207,6.207,0,0,1,.708,2.9v.01a1.838,1.838,0,0,1-1.836,1.836H28.169a1.835,1.835,0,0,1-1.015-.307,3.047,3.047,0,0,0,.41-1.529v-.01a7.467,7.467,0,0,0-.556-2.834,6.276,6.276,0,0,1,9.694-1.924.615.615,0,0,0,.8-.932,7.491,7.491,0,0,0-2.24-1.331,5.127,5.127,0,1,0-5.312,0,7.536,7.536,0,0,0-3.622,2.9,7.546,7.546,0,0,0-3.616-2.9,5.127,5.127,0,1,0-5.315,0,7.548,7.548,0,0,0-3.617,2.905,7.508,7.508,0,0,0-3.616-2.907,5.127,5.127,0,1,0-5.319,0,7.486,7.486,0,0,0-2.584,1.649.615.615,0,1,0,.859.881,6.277,6.277,0,0,1,9.984,1.658,7.469,7.469,0,0,0-.556,2.834v.01a3.047,3.047,0,0,0,.41,1.529,1.835,1.835,0,0,1-1.015.307H3.067a1.838,1.838,0,0,1-1.836-1.836v-.01a6.237,6.237,0,0,1,.513-2.49.615.615,0,1,0-1.129-.488A7.458,7.458,0,0,0,0,289.533v.01a3.07,3.07,0,0,0,3.066,3.067h8.879A3.065,3.065,0,0,0,13.782,292a3.049,3.049,0,0,0,1.835.612H24.5A3.047,3.047,0,0,0,26.333,292a3.065,3.065,0,0,0,1.836.612h8.879a3.07,3.07,0,0,0,3.066-3.067v-.01a7.527,7.527,0,0,0-.847-3.468Zm-10.555-7.937a3.9,3.9,0,1,1,3.9,3.9A3.9,3.9,0,0,1,28.712,278.128Zm-25.1,0a3.9,3.9,0,1,1,3.9,3.9A3.9,3.9,0,0,1,3.61,278.128Zm12.551,0a3.9,3.9,0,1,1,3.9,3.9A3.9,3.9,0,0,1,16.161,278.128Zm-.543,13.252a1.838,1.838,0,0,1-1.836-1.836v-.01a6.275,6.275,0,1,1,12.551,0v.01a1.838,1.838,0,0,1-1.836,1.836Zm0,0"
                        transform="translate(-0.001 -250.61)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83987"
                        data-name="Path 83987"
                        d="M369.488,344.638a3.718,3.718,0,0,1-3.5,0,.615.615,0,0,0-.592,1.079,4.947,4.947,0,0,0,4.683,0,.616.616,0,1,0-.594-1.079Zm0,0"
                        transform="translate(-335.134 -316.298)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83988"
                        data-name="Path 83988"
                        d="M376.915,313.588a.615.615,0,1,1-.615-.615A.616.616,0,0,1,376.915,313.588Zm0,0"
                        transform="translate(-344.866 -287.3)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83989"
                        data-name="Path 83989"
                        d="M405.547,313.588a.615.615,0,1,1-.615-.615A.615.615,0,0,1,405.547,313.588Zm0,0"
                        transform="translate(-371.151 -287.3)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83990"
                        data-name="Path 83990"
                        d="M216.488,344.638a3.718,3.718,0,0,1-3.5,0,.615.615,0,0,0-.592,1.079,4.947,4.947,0,0,0,4.683,0,.616.616,0,1,0-.594-1.079Zm0,0"
                        transform="translate(-194.683 -316.298)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83991"
                        data-name="Path 83991"
                        d="M223.915,313.588a.615.615,0,1,1-.615-.615A.616.616,0,0,1,223.915,313.588Zm0,0"
                        transform="translate(-204.417 -287.3)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83992"
                        data-name="Path 83992"
                        d="M252.547,313.588a.615.615,0,1,1-.615-.615A.615.615,0,0,1,252.547,313.588Zm0,0"
                        transform="translate(-230.7 -287.3)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83993"
                        data-name="Path 83993"
                        d="M287.615,91.489h8.7a.615.615,0,0,0,0-1.231h-8.7a.615.615,0,0,0,0,1.231Zm0,0"
                        transform="translate(-263.459 -82.854)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83994"
                        data-name="Path 83994"
                        d="M287.615,121.489h8.7a.615.615,0,0,0,0-1.231h-8.7a.615.615,0,0,0,0,1.231Zm0,0"
                        transform="translate(-263.459 -110.393)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83995"
                        data-name="Path 83995"
                        d="M287.615,151.489h8.7a.615.615,0,0,0,0-1.231h-8.7a.615.615,0,0,0,0,1.231Zm0,0"
                        transform="translate(-263.459 -137.932)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83996"
                        data-name="Path 83996"
                        d="M26.715,17.088h2.946a4.88,4.88,0,0,0,1.7,3.487,3.97,3.97,0,0,0,2.435.759,5.785,5.785,0,0,0,1.213-.133.708.708,0,0,0-.025-1.39,1.1,1.1,0,0,1-.8-.509,3.471,3.471,0,0,1-.173-2.213h3.8a4.192,4.192,0,0,0,1.866-.437,4.245,4.245,0,0,0,3.938,2.714h3.8a3.467,3.467,0,0,1-.173,2.214,1.1,1.1,0,0,1-.8.509.711.711,0,0,0-.583.684.7.7,0,0,0,.558.706,5.782,5.782,0,0,0,1.213.133,3.972,3.972,0,0,0,2.436-.759,4.88,4.88,0,0,0,1.7-3.487h2.946a4.218,4.218,0,0,0,4.215-4.213V6.491a4.218,4.218,0,0,0-4.215-4.213H43.613a4.233,4.233,0,0,0-1.866.436A4.221,4.221,0,0,0,37.809,0h-7.6a.615.615,0,0,0,0,1.231h7.6a2.986,2.986,0,0,1,2.984,2.982v8.663a2.986,2.986,0,0,1-2.984,2.982H33.522a.615.615,0,0,0-.59.441,5.132,5.132,0,0,0,.2,3.648c.023.037.046.073.071.108a2.5,2.5,0,0,1-1.1-.461,4.091,4.091,0,0,1-1.268-3.158.616.616,0,0,0-.614-.579h-3.51a2.986,2.986,0,0,1-2.984-2.982V4.213a2.986,2.986,0,0,1,2.984-2.982h.872a.615.615,0,0,0,0-1.231h-.872A4.218,4.218,0,0,0,22.5,4.213v8.663a4.218,4.218,0,0,0,4.214,4.213Zm15.309-4.213V4.213c0-.081,0-.162-.007-.241a2.949,2.949,0,0,1,1.6-.463H54.707a2.986,2.986,0,0,1,2.984,2.982v8.662a2.987,2.987,0,0,1-2.984,2.982H51.2a.616.616,0,0,0-.614.579,4.092,4.092,0,0,1-1.267,3.158,2.5,2.5,0,0,1-1.1.461c.025-.036.048-.071.071-.109a5.131,5.131,0,0,0,.2-3.648.615.615,0,0,0-.59-.441H43.613a3,3,0,0,1-2.886-2.224,4.2,4.2,0,0,0,1.3-3.035Zm0,0"
                        transform="translate(-20.654 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_83997"
                        data-name="Path 83997"
                        d="M72,50.02c0,1.292.671,3.815,5.168,6.194a1.143,1.143,0,0,0,1.069,0c4.5-2.379,5.168-4.9,5.168-6.194a3.318,3.318,0,0,0-3.159-3.52,3.749,3.749,0,0,0-2.544,1,3.749,3.749,0,0,0-2.544-1A3.318,3.318,0,0,0,72,50.02Zm3.159-2.289a2.51,2.51,0,0,1,1.814.778,1.026,1.026,0,0,0,1.459,0,2.509,2.509,0,0,1,1.814-.778,2.1,2.1,0,0,1,1.928,2.289c0,1.72-1.629,3.572-4.472,5.084-2.843-1.513-4.472-3.364-4.472-5.084a2.1,2.1,0,0,1,1.928-2.289Zm0,0"
                        transform="translate(-66.092 -42.685)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </div>
                <p>
                  Get Real-Time Updates Coach / Scout Activity, Events, Video,
                  Teammates, & More
                </p>
              </div>
            </div>
            <div className="item">
              <div className="coach-cartbox">
                <div className="title-info">
                  <div className="title">Notifications</div>
                  <div className="iconbox">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39.3"
                      height="42.801"
                      viewBox="0 0 39.3 42.801"
                    >
                      <g
                        id="_008-notification"
                        data-name="008-notification"
                        transform="translate(0.4 0.4)"
                      >
                        <path
                          id="Path_83998"
                          data-name="Path 83998"
                          d="M140.036,424.045a6.713,6.713,0,0,1-6.7-6.7,1.341,1.341,0,0,1,2.682,0,4.023,4.023,0,1,0,8.045,0,1.341,1.341,0,0,1,2.682,0A6.712,6.712,0,0,1,140.036,424.045Zm0,0"
                          transform="translate(-122.517 -382.045)"
                          fill="#fff"
                          stroke="#00b9ff"
                          stroke-width="0.8"
                        />
                        <path
                          id="Path_83999"
                          data-name="Path 83999"
                          d="M31.868,95.273H3.056a3.038,3.038,0,0,1-1.987-5.351,1.205,1.205,0,0,1,.14-.1,11.652,11.652,0,0,0,4.03-8.809V76.162A12.207,12.207,0,0,1,17.462,64a5.287,5.287,0,0,1,.861.052,1.3,1.3,0,1,1-.43,2.57,2.763,2.763,0,0,0-.431-.016,9.591,9.591,0,0,0-9.6,9.556v4.847A14.26,14.26,0,0,1,2.789,91.9c-.026.021-.049.04-.077.059a.429.429,0,0,0-.092.269.44.44,0,0,0,.436.434H31.868a.44.44,0,0,0,.437-.434.414.414,0,0,0-.094-.269c-.026-.019-.049-.038-.075-.059a14.257,14.257,0,0,1-5.069-10.9V79.116a1.31,1.31,0,0,1,2.619,0v1.893a11.656,11.656,0,0,0,4.035,8.814,1.272,1.272,0,0,1,.134.1,3.037,3.037,0,0,1-1.987,5.349Zm0,0"
                          transform="translate(0 -58.637)"
                          fill="#fff"
                          stroke="#00b9ff"
                          stroke-width="0.8"
                        />
                        <path
                          id="Path_84000"
                          data-name="Path 84000"
                          d="M264.939,17.878a8.939,8.939,0,1,1,8.939-8.939A8.949,8.949,0,0,1,264.939,17.878Zm0-15.2A6.257,6.257,0,1,0,271.2,8.939a6.264,6.264,0,0,0-6.257-6.257Zm0,0"
                          transform="translate(-235.378)"
                          fill="#fff"
                          stroke="#00b9ff"
                          stroke-width="0.8"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
                <p>
                  Get Notifications That Matter Coach Connections, Messages,
                  Videos, & Checklist Items
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="get-started-sec">
        <div className="container">
          <div className="get-started-flexbox">
            <h3 className="sec-title">
              Learn How to Maximize Your Recruiting Exposure.
              <br />
              See if You Have What it Takes to Get Recruited
            </h3>
            <div className="button-wrap">
              <a className="btn" href="https://calendly.com/sportsforceteam/consultation?month=2025-04&date=2025-04-17" target="_blank" rel="noopener noreferrer">
                Book Your Strategy Call
              </a>
            </div>
          </div>
        </div>
      </section>
      <AthleteTestimonials grayBackground />
      <section className="lp-map-sec">
        <div className="container">
          <h3 className="sec-title">
            We carefully maintain a Trusted Network of College Coaches at the
            NCAA DI, DII, DIII, NAIA & JC
          </h3>
        </div>
        <div className="map-box">
          <img src={HomeMapIMG} alt="Trusted Network of College" />
        </div>
      </section>
      <section className="brand-lp-sec mb-1">
        <div className="container">
          <div className="brand-listing">
            <div className="item">
              <img src={NCAAIMG} alt="" />
            </div>
            <div className="item">
              <img src={NAIAIMG} alt="" />
            </div>
            <div className="item">
              <img src={NJCAA} alt="" />
            </div>
            <div className="item">
              <img
                src={CaliforniaCommunityCollegeAthleticAssociationIMG}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <footer id="footer"></footer>
      <VideoPop
        isTestSingle={isVideoPop}
        setIsTestSingle={() => setIsVideoPop(false)}
        vidID={vidID}
      />
    </>
  );
};

export default AthleteLP;
